import { useCallback } from 'react';

import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { Document, ErrorMessage, IssuedDocumentSign } from 'types';
import { client } from 'utils/api-client';

export default function useSignDocument(): UseMutationResult<
  AxiosResponse<Document>,
  AxiosError<ErrorMessage>,
  IssuedDocumentSign
> {
  const queryClient = useQueryClient();

  const signDocument = useCallback((document: IssuedDocumentSign): Promise<AxiosResponse<Document>> => {
    return client.put(`documents/${document.documentId}/sign/`, document);
  }, []);

  return useMutation(signDocument, {
    onSuccess: () => {
      queryClient.invalidateQueries('documents');
    },
  });
}
